export const SUPPORTS_OBJECT_VALUES = "values" in Object;
